<template>
	<div id ="oficio" class="table-responsive-lg recibo">
		<!--oficio-->
		<div class="oficio-devol">
		<table class="encabezado-devol"style=" width: 100%">
			<tr>
				<td><img class="logo" src="..\..\..\assets\logo-pj-transparente-negro-recibo.png" alt="logo" ></td>
				<td style="text-align: right">No.de Oficio: <b>FAJ-{{devolucion.NumeroOficioOficialia}}</b><br><br>
					{{(datosDevolucion.Expediente.TipoDocumento.Nombre)  +': '}}<b>{{((datosDevolucion.Expediente.Consecutivo != null) ? datosDevolucion.Expediente.Consecutivo : '') +  ((datosDevolucion.Expediente.NumeroRomano != null) ? '-' + datosDevolucion.Expediente.NumeroRomano : '')}}</b>

				</td>
			</tr>
		</table><br>
		<p class="destinatario-oficio">
			{{devolucion.TituloDestinatario.Nombre + ' ' + devolucion.NombreDestinatario}}<br>
			{{devolucion.PuestoDestinatario.Nombre 
				+ ' DEL ' 
				+ datosDevolucion.Expediente.Area.Nombre.toUpperCase() 
				+ ' DEL ' + datosDevolucion.Expediente.PartidoJudicial.Nombre.toUpperCase() 
				+ ' EN EL ESTADO ' }}<br>
			{{'PRESENTE.'}}
		</p><br>




		<p v-if="folios && folios.length > 1">
			&emsp;Adjunto al presente, recibo y copia del cheque de {{devolucion.TipoBanco.Nombre}} numero <b>{{devolucion.NumeroCheque}}</b>
			a nombre de <b>{{devolucion.Persona.Nombre + ' ' +  ((devolucion.Persona.ApellidoPaterno != null) ? devolucion.Persona.ApellidoPaterno : '') + ' ' + ((devolucion.Persona.ApellidoMaterno != null) ?  devolucion.Persona.ApellidoMaterno : '')}}</b>
			por la cantidad de <b>{{numerosAPalabras(datosDevolucion.Devoluciones[0].SumaDevoluciones) + (datosDevolucion.Devoluciones[0].SumaDevoluciones == 1 ? ' PESO' : ' PESOS') + ' ' +(datosDevolucion.Devoluciones[0].SumaDevoluciones % 1).toFixed(2).substring(2) + '/100 M.N.'}}</b> que se desprende de los recibos de caja siguientes: 
			<table class="encabezado-devol table-bordered "style=" width: 100%; text-align: center;">
				<tr>
					<th>Folio de recibo</th>
					<th>Importe devuelto</th>
				</tr>
				<tr v-for="folio in folios">
					<td>{{folio.numeroFolio}}</td>
					<td>{{'$' + agregarCeros(folio.pagado)}}</td>
				</tr>
			</table> 
			<span v-for="folio in folios">
				{{folio.observacion}}
			</span>
			Importe entregado en cumplimiento a lo ordenado dentro de los autos del expediente al rubro anotado.
		</p>





		<p v-else-if="folios && folios.length == 1">
			&emsp;Adjunto al presente, recibo y copia del cheque de {{devolucion.TipoBanco.Nombre}} numero <b>{{devolucion.NumeroCheque}}</b>
			a nombre de <b>{{devolucion.Persona.Nombre + ' ' +  ((devolucion.Persona.ApellidoPaterno != null) ? devolucion.Persona.ApellidoPaterno : '') + ' ' + ((devolucion.Persona.ApellidoMaterno != null) ?  devolucion.Persona.ApellidoMaterno : '')}}</b>
			por la cantidad de <b>{{numerosAPalabras(folios[0].pagado) + (folios[0].pagado == 1 ? ' PESO' : ' PESOS') + ' ' +(folios[0].pagado % 1).toFixed(2).substring(2) + '/100 M.N.'}}</b> que se desprende del recibo de caja <b>{{folios[0].numeroFolio}}</b>.
			<span>
				{{folios[0].observacion}}
			</span> 
			Importe entregado en cumplimiento a lo ordenado dentro de los autos del expediente al rubro anotado.
		</p><br>





		<p>&emsp;Agradeciendo su atención, quedo a sus órdenes para cualquier comentario al respecto.</p>
		<p style="text-align: center;"><br><br>ATENTAMENTE.<br>
			AGUASCALIENTES, AGS., A {{FechaAPalabras(devolucion.FechadeDevolucion)}}<br>
			<b>{{devolucion.TituloRemitente.Nombre + ' ' + devolucion.NombreRemitente}}<br><br><br>
			{{devolucion.PuestoRemitente.Nombre}} DEL PODER JUDICIAL</b>
		</p>
		</div>


		<div class="pagebreak">

		</div>
<!--recibo-->
		<div v-for="index in 2" class="recibo-devol" style="width: 100%;">
			<table class="recibo-devol">
				<tr>
					<td style="text-align: center; width: 33%; "><img class="logo" src="..\..\..\assets\logo-pj-transparente-negro-recibo.png" alt="logo" ></td>
				</tr>
				<tr>
					<td style="text-align: center; width: 33%;"><b>PODER JUDICIAL DEL ESTADO DE AGUASCALIENTES<br><br>
					RECIBO DE PAGO</b></td>
				</tr>
				<tr>
					<td style="text-align: right; width: 33%; ">Fecha: {{FechaDDMMAAAA(devolucion.FechadeDevolucion)}}</td>
				</tr>
			</table>
			<br><br>
			<table class="recibo-devol-sub">
				<tr >
					<td style="text-align: center;">{{datosDevolucion.Expediente.TipoDocumento.Nombre + ': '  }}<b>{{datosDevolucion.Expediente.Consecutivo +  ((datosDevolucion.Expediente.NumeroRomano != null) ? '-' + datosDevolucion.Expediente.NumeroRomano : '') + '' }}</b></td>
					<td style="text-align: center;">{{datosDevolucion.Expediente.Area.Nombre}}</td>
					<td style="text-align: center;">{{(folios.map((lista) => lista.numeroOficioJuzgado).filter((numero, index, array) => array.indexOf(numero) === index).length > 1) ? 'OFICIOS DE JUZGADO: ' : 'OFICIO DE JUZGADO: '}}<b>{{folios.map((lista) => lista.numeroOficioJuzgado).filter((numero, index, array) => array.indexOf(numero) === index).sort((a, b) => {return a - b}).join(", ").replace(/, ([^,]*)$/, ' Y $1')}}</b></td>
				</tr>
			</table>
			<table class="recibo-devol-sub">
				<tr >
					<td style="padding-left: 10px">{{(folios.length > 1) ? 'RECIBOS DE CAJA: ':'RECIBO DE CAJA: '}} <b>{{folios.map((lista) => lista.numeroFolio).sort((a, b) => {return a - b}).join(", ").replace(/, ([^,]*)$/, ' Y $1')}}</b></td>
				</tr>
			</table>
			<br><br>
			<p style="padding-left: 51px"><b>Recibí de la Oficialía Mayor del H. Supremo Tribunal de Justicia </b></p>
			<br>
			<table class="recibo-devol-sub" >
				<tr >
				<td style="padding-left: 10px">CHEQUE: <b> N° {{devolucion.NumeroCheque}} </b></td> <td style="padding-left: 10px"> de {{devolucion.TipoBanco.Nombre.toUpperCase()}}</td>
				</tr>

			</table>
			<table class="recibo-devol-sub" >
				<tr>
				<td style="padding-left: 10px">POR LA CANTIDAD DE: <b>{{'$'+agregarCeros(devolucion.SumaDevoluciones)}}</b></td>
				</tr>
			</table>
			<table class="recibo-devol-sub" >
				<tr >
				<td style="padding-left: 10px"><b>{{numerosAPalabras(devolucion.SumaDevoluciones) + (devolucion.SumaDevoluciones == 1 ? ' PESO' : ' PESOS') + ' ' +(devolucion.SumaDevoluciones % 1).toFixed(2).substring(2) + '/100 M.N.'}}</b></td>
				</tr>
				
			</table>
			<br><br><br>
			<table class="leyenda-recibo">
				<tr style="text-align: center;">
					<td><b>{{'____________________________'}}<br>{{primeraLetraMayuscula(devolucion.Persona.Nombre + ' ' +  ((devolucion.Persona.ApellidoPaterno != null) ? devolucion.Persona.ApellidoPaterno : '') + ' ' + ((devolucion.Persona.ApellidoMaterno != null) ?  devolucion.Persona.ApellidoMaterno : ''))}}</b></td>
					<td><b>{{'____________________________'}}<br>Fecha de recibido</b></td>
				</tr>
			</table>
			<div class="pagebreak" v-if="index == 1"></div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue'
	import VueHtmlToPaper from 'vue-html-to-paper'
	import api from '@/../static/js/api'
	import axios from 'axios'
	import comun from "@/../static/js/comun"
	import enumeraciones from '@/../static/js/enumeraciones'
	import func from '../Comun/Funciones/comun.js'


	Vue.use(VueHtmlToPaper)

	export default{
		data(){
			return{
				datosDevolucion : {
					Expediente:{
						Area:{
							Nombre: ''
						},
						TipoDocumento:{},
						PartidoJudicial:{
							Nombre: ''
						}
					},
					Devoluciones:[{	}]
				},
				devolucion: {
					Persona:{},
					TipoBanco:{
						Nombre: ''
					},
					TituloDestinatario:{},
					PuestoDestinatario:{},
					TituloRemitente:{},
					PuestoRemitente:{}

				},
				folios : []
				,
				montoOficio : 0
			}
		},
		methods:{
			async imprimirReciboDevolucion(devolucion, datosDevolucion){
				this.datosDevolucion = datosDevolucion
				this.devolucion = devolucion
				this.folios.length = 0;

				devolucion.Cheque.forEach((cheque)=>{
					
					this.folios.push({
						numeroFolio : cheque.Folio,
						pagado: cheque.Monto,
						observacion: cheque.Observaciones,
						numeroOficioJuzgado: cheque.NumeroOficioJuzgado,
					})
				})

				this.folios.sort((a, b) => {return a.numeroFolio - b.numeroFolio})

				setTimeout(() => {
	  				this.$htmlToPaper('oficio', {
	  				name: '_blank',
	  				styles: [
	  					'/static/css/bootstrap.min.css',
	  					'/static/css/recibo.css'
	  				],
  			// timeout: 1000, //no sirven 
  			// autoClose: true, 
  			//windowTitle: window.document.title,
  					}, ()=>{
  						//this.actualizarEstatusDevolucion(devolucion.DevolucionId)
  						console.log('imprimir')
  				});
	  		
		}, 1);//1 ms solo para que cargue el pdf, aumentar si se tarda

			},
			agregarCeros : function(monto){
	  			return func.agregarCeros(monto)
	  		},
	  		FechaDDMMAAAA : function(fecha){
	  			return func.FechaDDMMAAAA(fecha)
	  		},

	  		numerosAPalabras: function(numero){
	  			return func.numerosAPalabras(numero)
	  		},
	  		FechaAPalabras: function(fecha){
	  			return func.FechaAPalabras(fecha)
	  		},
	  		primeraLetraMayuscula: function(frase){
	  			return func.primeraLetraMayuscula(frase)
	  		}

		},
		props:{
			Pago : null
		}
	}

</script>
<style type="text/css">
	
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Caja/ReciboDevolucion.vue